import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals } from 'utils';
import { ServiceService, CallService } from 'services';
import { BackIcon, Calendar as CalendarIcon, ClockIcon, MailIcon } from 'assets/icons';
import { Button, Calendar, DatePicker, Input, Select, Textarea } from 'components';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

interface Props extends RootState, RouteComponentProps {
  title?: string;
  onClose?: (reload: boolean) => void;
}

const STEPS = {
  CALL_REQUEST: 1,
  DAYS: 2,
};

class CreateCalls extends React.Component<Props> {
  state = {
    step: STEPS.CALL_REQUEST,
    form: {
      description: '',
      day: '',
      hour: '',
    },
    disabled_days: [],
    hours: [],
  };

  getDisabledDays = async () => {
    const res: any = await CallService.disabledDays({});

    this.setState({
      disabled_days: res || [],
    });
  };

  getHours = async (day: string) => {
    const res: any = await CallService.availableHours({
      day,
    });

    this.setState((prev: any) => ({
      hours: res.hours || [],
      form: {
        ...prev.form,
        day,
      },
    }));
  };

  change = (e: any) => {
    const { name, value } = e.target;
    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    });
  };

  isValidNext = () => {
    const { form } = this.state;

    if (form.description == '') {
      Globals.showError('Ingrese el motivo de la consulta');
      return false;
    }

    return true;
  };

  next = () => {
    if (!this.isValidNext()) return;
    this.setState(
      {
        step: this.state.step + 1,
      },
      () => this.getDisabledDays(),
    );
  };

  isFormValid = () => {
    const { form } = this.state;

    if (form.description == '') {
      Globals.showError('Ingrese el motivo de la consulta');
      return false;
    }

    if (form.day == '') {
      Globals.showError('Seleccione un día');
      return false;
    }

    if (form.hour == '') {
      Globals.showError('Seleccione una hora');
      return false;
    }

    return true;
  };

  submit = async () => {
    if (!this.isFormValid()) return;
    const { form } = this.state;
    const { user } = this.props;

    try {
      const res: any = await CallService.create({
        user_id: user?.id,
        ...form,
      });
      if (!res) {
        Globals.showError('No se encontraron abogados disponibles, intentalo más tarde');
        return;
      }
      Globals.showSuccess('Llamada creada correctamente');
      this.props.onClose?.call(this, true);
    } catch (error) {}
  };

  onBack = () => {
    this.setState({
      step: STEPS.CALL_REQUEST,
    });
  };

  render() {
    const { step, disabled_days, hours } = this.state;

    return (
      <div id='modal-create-calls'>
        <Modal.Header closeButton>
          <div className='header'>
            {step === STEPS.DAYS && <img src={BackIcon} alt='clock' onClick={this.onBack} />}
            <Modal.Title>Solicitud de llamada</Modal.Title>
          </div>
        </Modal.Header>
        <div className='steps'>
          <div className='step active'>
            <img src={MailIcon} alt='clock' className='active' />
            <span className='active'>Motivo</span>
          </div>
          <div className='line'></div>
          <div className={`step ${step == STEPS.DAYS ? 'active' : ''}`}>
            <img src={CalendarIcon} alt='calendar' className={step == STEPS.DAYS ? 'active' : ''} />
            <span>Agendar</span>
          </div>
        </div>

        {step == STEPS.CALL_REQUEST && (
          <>
            <div className='row'>
              <div className='col-md-12'>
                <div className='px-3'>
                  <Textarea
                    rows={6}
                    value={this.state.form.description}
                    placeholder='Motivo de la consulta'
                    name='description'
                    onChange={this.change}
                  />
                  <Button
                    title='Siguiente'
                    block
                    className='mb-3'
                    color='green'
                    onClick={() => this.next()}
                    disabled={this.state.form.description == ''}
                  >
                    Siguiente
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}

        {step == STEPS.DAYS && disabled_days.length !== 7 ? (
          <>
            <Calendar
              value={this.state.form.day}
              disabledWeekDays={disabled_days}
              minDate={moment().toISOString()}
              onSelectDate={(date) => this.getHours(date)}
            />
            <div className='mt-3 px-3'>
              <p className='placeholder'>Horario disponible</p>
              <div className='row'>
                <div className='col-md-8'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    name='hour'
                    onChange={this.change}
                    value={this.state.form.hour}
                    options={hours.map((item: string) => {
                      const [start, end] = item.split(',');
                      const toFormatStart = moment(start, 'HH:mm').format('hh:mm A');
                      const toFormatEnd = moment(end, 'HH:mm').format('hh:mm A');
                      return {
                        value: item,
                        label: `${toFormatStart} a ${toFormatEnd}`,
                      };
                    })}
                  />
                </div>
              </div>
              <Button
                title='Eviar'
                block
                className='mb-3'
                color='green'
                onClick={() => this.submit()}
              >
                Enviar
              </Button>
            </div>
          </>
        ) : (
          step == STEPS.DAYS &&
          disabled_days.length === 7 && <p className='text-center'>No hay días disponibles</p>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(CreateCalls);
